import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";

const ReturnRefundPolicyScreen = () => {
  const { t } = useTranslation();

  return (
    <Container className="pb-3">
      <h3 className="py-4">{t('return_refund_policy_title')}</h3>
      
      <section>
        <ul>
          <li className="pb-3">{t('return_refund_policy_description_1')}</li>
          <li className="pb-3">{t('return_refund_policy_description_2')}</li>
          <li className="pb-3">{t('return_refund_policy_description_3')}</li>
          <li className="pb-3">{t('return_refund_policy_description_4')}</li>
          <li className="pb-2">{t('return_refund_policy_description_5')}</li>
        </ul>
      </section>
    </Container>
  );
};

export default ReturnRefundPolicyScreen;
